import React from "react"
import ReactDOM from "react-dom"
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from "react-router-dom"
import ConfigPage from "./pages/Config"
import DeliveryPage from "./pages/Delivery"
import HomePage from "./pages/Home"
import PaymentPage from "./pages/Payment"
import ProductsPage from "./pages/Products"
import DefaultLayout from "./layout/DefaultLayout"
import CartPage from "./pages/Cart"
import getReadyToPayWallets from "./helpers/getReadyToPayWallets"

getReadyToPayWallets().then(response => {
  console.log("getReadyToPayWalletsResponse", response)
})

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<DefaultLayout />}>
      <Route index element={<HomePage />} />
      <Route path="config" element={<ConfigPage />} />
      <Route path="cart" element={<CartPage />}>
        <Route index element={<ProductsPage />} />
        <Route path="delivery" element={<DeliveryPage />} />
        <Route path="payment" element={<PaymentPage />} />
      </Route>
    </Route>
  )
)

ReactDOM.render(<RouterProvider router={router} />, document.getElementById("root"))
